export enum BrowserType {
  TWA = 'twa',
  CCT = 'cct',
  SFSVC = 'sfsvc',
  WEBVIEW = 'webview',
  EXTERNAL = 'external',
}
